import React from 'react';
import { NavLink } from 'react-router-dom';
import { AlertList } from 'react-bs-notifier';
import { apiGet, apiPost, apiPut } from '../../../services/apiClient';
import { getRoles } from '../../../services/userRights';
import InformationModal from '../../../modals/infoModal.jsx';
import ConfirmModal from '../../../modals/confirmModal.jsx';
import AddressTab from './tabs/addressTab.jsx';
import CargoTab from './tabs/cargoTab.jsx';
import CostCalcTab from './tabs/costCalcTab.jsx';
import PayerTab from './tabs/payerTab.jsx';
import HistoryTab from './tabs/historyTab.jsx';
import DocumentsTab from './tabs/documentsTab.jsx';
import Forbidden from '../../forbidden/forbidden.jsx';
import NotFound from '../../notFound/notFound.jsx';

export default class ParcelForm extends React.Component {
    constructor(args) {
        super(args);

        this.cargoTab = null;
        this.addressTab = null;
        this.costCalcTab = null;
        this.payerTab = null;
        this.historyTab = null;
        this.documentsTab = null;

        this.confirmChangeStatusModal = null;
		this.infoModal = null;

		let isNew = this.props.location.state && this.props.location.state.isNew;
        
        this.state = {
            id: this.props.match.params.id,
			isNew: isNew,
            busyCount: 0,
            lastResponseError: null,
            errors: {},
            parcel: {},
            initParcel: {},
            history: [],
			documents: [],
            nextStatuses: [],
			alerts: [],
            activeTab: "address"
        };
        this.setNewStatus = this.setNewStatus.bind(this);
    }
	
	componentWillMount() {
		this.props.history.replace({
			pathname: '/parcels/' + this.state.id,
			state: {}
		});
    }

    componentDidMount() {
        this.reload()
			.then(() => {
				if (this.state.isNew) {
					let hasDocuments = this.state.documents && this.state.documents.length > 0;
					if (hasDocuments) {
						this.openTab("documents");
						this.setState((prevState, props) => {
							prevState.alerts.push(this.generateNewDocumentsAlert());
							return prevState;
						});
					}
				}
			});
		$('[data-toggle="popover"]').popover();
    }

    componentWillReceiveProps(newProps) {
		if (this.state.id !== newProps.match.params.id) {
			this.setState(
				{
					id: newProps.match.params.id,
					isNew: false,
					errors: {}
				},
				() => this.reload()
			);
		}
    }

    updateBusyCount(inc) {
        this.setState((prevState, props) => {
            prevState.busyCount = prevState.busyCount + inc;
            return prevState;
        });
    }

    reload() {
        return this.reloadParcelData()
            .then(() => {
                let loadCargo = this.cargoTab.reloadReferences();
                let loadAddress = this.addressTab.reloadReferences();
                let loadCostCalc = this.costCalcTab.reloadReferences();
                let loadPayer = this.payerTab.reloadReferences();
                let loadHistory = this.reloadHistory();
                let loadDocuments = this.reloadDocuments();

                return Promise.all([loadCargo, loadAddress, loadCostCalc, loadPayer, loadHistory, loadDocuments])
							  .then(() => this.validateAll());
            })
            .catch(() => { });
    }

    reloadHistory() {
        this.updateBusyCount(1);
        return apiGet('parcels/' + this.state.id + '/history')
            .then(data => {
                this.updateBusyCount(-1);
                this.setState({ history: data.entries });
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });
    }

    reloadDocuments() {
        this.updateBusyCount(1);
        return apiGet('parcels/documents/' + this.state.id + '/list')
            .then(data => {
                this.updateBusyCount(-1);
                this.setState({ documents: data.entries });
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });
    }

    reloadParcelData() {
        this.updateBusyCount(1);
        apiGet('parcels/' + this.state.id + '/status/next')
            .then(data => {
                this.updateBusyCount(-1);
                this.setState((prevState, props) => {
                    prevState.nextStatuses = data.entries;
                    return prevState;
                });
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });

        this.updateBusyCount(1);
        return apiGet('parcels/' + this.state.id)
            .then(data => {
				if (data.carrierCostRequests) {
					data.carrierCostRequests.forEach((entry, ind, arr) => {
						if (entry.isSelected) {
							entry.isDeliveryTimeSpecified = data.isDeliveryTimeSpecified;
							entry.deliveryTime = data.deliveryTime;
						}
					});
				}
                let initValue = $.extend(true, {}, data);
                this.updateBusyCount(-1);
                this.setState((prevState, props) => {
                    prevState.parcel = data;
                    prevState.initParcel = initValue;
                    return prevState;
                });
            })
            .catch(err => {
                this.updateBusyCount(-1);
                if (err.status > 401) {
                    this.setState({ lastResponseError: err.status });
                }
            });
    }

    clearErrors() {
        this.setState({ errors: {} });
    }

    backToList() {
        this.props.history.push('/parcels/list');
    }

    openTab(tabName) {
        this.setState({ activeTab: tabName });
    }

    syncInitState() {
        this.setState({
            initParcel: $.extend(true, {}, this.state.parcel)
        });
    }

    validateAll() {
        let errors = {};
        let addressErrors = this.addressTab.validateForm();
        if (addressErrors) {
            $.extend(true, errors, addressErrors);
        }
        let cargoErrors = this.cargoTab.validateForm();
        if (cargoErrors) {
            $.extend(true, errors, cargoErrors);
        }
        let costCalcErrors = this.costCalcTab.validateForm();
        if (costCalcErrors) {
            $.extend(true, errors, costCalcErrors);
        }
        let payerErrors = this.payerTab.validateForm();
        if (payerErrors) {
            $.extend(true, errors, payerErrors);
        }
        this.setState({ errors: errors });
    }

    handleFieldEdited(fieldName, value) {
        let initValue = this.state.initParcel[fieldName];
        if (value === initValue) {
            return;
        }

        let errors = this.addressTab.validateForm(fieldName);
        if (!errors) {
            errors = this.cargoTab.validateForm(fieldName);
        }
        if (!errors) {
            errors = this.costCalcTab.validateForm(fieldName);
        }
        if (!errors) {
            errors = this.payerTab.validateForm(fieldName);
        }

        if (errors) {
            this.validateAll();
        } else {
            this.updateBusyCount(1);
            let request = {
                fieldName: fieldName,
                value: value
            };
            apiPost('parcels/' + this.state.id + '/field', request)
                .then(data => {
                    this.updateBusyCount(-1);
                    if (data.needReload) {
                        this.reload();
                    } else {
                        this.reloadHistory();
                        this.validateAll();
                    }
                    this.syncInitState();
                })
                .catch(err => {
                    this.updateBusyCount(-1);
                    this.validateAll();
                    if (err.error) {
                        this.setState((prevState, props) => {
                            prevState.errors[fieldName] = err.error;
                            return prevState;
                        });
                    }
                });
        }
    }

    handleFieldChange(newFieldValues) {
		let promise = new Promise((resolve, reject) => {
			let parcel = this.state.parcel;
			newFieldValues.map((field, ind, arr) => {
				parcel[field.name] = field.value;
			});
			this.setState(
				{ parcel: parcel },
				() => resolve()
			);
		});
		return promise;
    }

	dismissAlert(alert) {
		this.setState((prevState, props) => {
			let newAlerts = [];
			prevState.alerts.forEach((item, int, arr) => {
				if (alert.id !== item.id) {
					newAlerts.push(item);
				}
			});
			prevState.alerts = newAlerts;
			return prevState;
		});
	}

	generateAlert(alertType, alertMessage) {
		let newAlert = {
			id: (new Date()).getTime(),
			type: alertType,
			timeout: 60000,
			message: alertMessage
		};
		return newAlert;
	}

	generateChangeStateProblemsAlert() {
		return this.generateAlert("warning", "Не удалось сменить статус на запрошенный. Более подробную информацию можно найти на вкладке История.");
	}

	generateNewDocumentsAlert() {
		return this.generateAlert("info", "Получены новые документы, вы можете распечатать их на вкладке Документы.");
	}

    setNewStatus(nextStatusId) {
        apiPost('parcels/' + this.state.id + '/status/' + nextStatusId)
            .then(data => {
                this.updateBusyCount(-1);
                this.reload()
                    .then(() => {
                        if (data.newDocuments) {
                            this.openTab("documents");
                        } else if (data.anotherFinalState || data.stateNotChanged) {
                            this.openTab("history");
                        }
                        this.setState((prevState, props) => {
                            if (data.stateNotChanged || data.anotherFinalState) {
                                prevState.alerts.push(this.generateChangeStateProblemsAlert());
                            }
                            if (data.newDocuments) {
                                prevState.alerts.push(this.generateNewDocumentsAlert());
                            }
                            return prevState;
                        });
                    });
            })
            .catch(err => {
                this.updateBusyCount(-1);
                if (err.messages) {
                    this.setState({ errors: err.messages });
                    this.infoModal.open(title, 'Не соблюдены условия для смены статуса посылки');
                }
            });
    }

    handleApplyStatus(nextStatusId, nextStatusName) {
        let title = 'Изменение статуса посылки ' + this.state.parcel.number;
        let message = 'Вы действительно хотите изменить статус посылки на ' + nextStatusName + '?';
        this.confirmChangeStatusModal.open(title, message)
            .then(() => {
                this.updateBusyCount(1);
                this.setNewStatus(nextStatusId);
            })
            .catch(() => { });
    }

	renderBusyOverlay(isBusy) {
        return isBusy
            ? <div className="overlay">
                <i className="fa fa-refresh fa-spin"></i>
              </div>
            : null;
	}

    render() {
        if (this.state.lastResponseError === 403) {
            return <Forbidden />;
        }
        if (this.state.lastResponseError === 404) {
            return <NotFound />;
        }  
		
        let isBusy = this.state.busyCount > 0;

        let nextStatuses = this.state.nextStatuses.map((status, ind, arr) => {
            let key = 'next-status-' + status.id;
            return (
                <li key={key}>
                    <a onClick={() => this.handleApplyStatus(status.id, status.name)}>{status.name}</a>
                </li>
            );
        });

        let changeStatusButton = this.state.nextStatuses.length > 0
            ? (
                <div className="btn-group pull-right btn-tool">
                    <button type="button"
                        className="btn btn-sm btn-flat btn-default dropdown-toggle"
                        data-toggle="dropdown"
                        aria-expanded="false"
                        disabled={isBusy}
                    >
                        <span>Изменить статус</span>
                        <span className="caret" style={{ marginLeft: "4px" }}></span>
                    </button>
                    <ul className="dropdown-menu" role="menu">
                        {nextStatuses}
                    </ul>
                </div>
            )
            : null;

        let hasAddressErrors = this.addressTab ? this.addressTab.hasFormErrors(this.state.errors) : false;
        let hasCargoErrors = this.cargoTab ? this.cargoTab.hasFormErrors(this.state.errors) : false;
        let hasCostCalcErrors = this.costCalcTab ? this.costCalcTab.hasFormErrors(this.state.errors) : false;
        let hasPayerErrors = this.payerTab ? this.payerTab.hasFormErrors(this.state.errors) : false;

        let addressTabClass = (this.state.activeTab === "address" ? "active " : "") + (hasAddressErrors ? "has-error " : "") + "clickable-tab";
        let cargoTabClass = (this.state.activeTab === "cargo" ? "active " : "") + (hasCargoErrors ? "has-error " : "") + "clickable-tab";
        let costCalcTabClass = (this.state.activeTab === "costCalc" ? "active " : "") + (hasCostCalcErrors ? "has-error " : "") + "clickable-tab";
        let payerTabClass = (this.state.activeTab === "payer" ? "active " : "") + (hasPayerErrors ? "has-error " : "") + "clickable-tab";
        let documentsTabClass = (this.state.activeTab === "documents" ? "active " : "") + "clickable-tab";
        let historyTabClass = (this.state.activeTab === "history" ? "active " : "") + "clickable-tab";

		let isCarrier = getRoles().indexOf('Carrier') >= 0;
		let tabs = isCarrier ? (
            <ul className="nav nav-tabs">
                <li className={addressTabClass}>
                    <a onClick={() => this.openTab("address")}>Адрес</a>
                </li>
                <li className={cargoTabClass}>
                    <a onClick={() => this.openTab("cargo")}>Посылка</a>
                </li>
            </ul>
		
		) : (
            <ul className="nav nav-tabs">
                <li className={addressTabClass}>
                    <a onClick={() => this.openTab("address")}>Адрес</a>
                </li>
                <li className={cargoTabClass}>
                    <a onClick={() => this.openTab("cargo")}>Посылка</a>
                </li>
                <li className={payerTabClass}>
                    <a onClick={() => this.openTab("payer")}>Плательщик</a>
                </li>
                <li className={costCalcTabClass}>
                    <a onClick={() => this.openTab("costCalc")}>Расчет стоимости</a>
                </li>
                <li className={documentsTabClass}>
                    <a onClick={() => this.openTab("documents")}>Документы</a>
                </li>
                <li className={historyTabClass}>
                    <a onClick={() => this.openTab("history")}>История</a>
                </li>
            </ul>
		);
        
        return (
            <div>
				<AlertList alerts={this.state.alerts} onDismiss={(item) => this.dismissAlert(item)} />

                <section className="content-header">
                    <h1>Посылка номер {this.state.parcel.number}</h1>
                    <ol className="breadcrumb">
                        <li><NavLink to="/parcels/list"><i className="fa fa-inbox"></i> Мои посылки</NavLink></li>
                        <li className="active">{this.state.parcel.number}</li>
                    </ol>
                </section>

                <section className="content">	
                    <div className="row">
                        <div className="col-xs-12 col-lg-10 col-lg-offset-1">
                            <div className="box box-primary">
                                <div className="box-header">
                                    <span>Статус: <span className="status-title">{this.state.parcel.statusName}</span></span>
                                    <div className="btn-group pull-right btn-tool">
                                        <button type="button"
                                            className="btn btn-sm btn-flat btn-default"
                                            onClick={() => this.backToList()}
                                            disabled={isBusy}
                                        >
                                            Закрыть
                                        </button>
                                    </div>
                                    {changeStatusButton}
                                    <ConfirmModal ref={modal => this.confirmChangeStatusModal = modal} />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-xs-12 col-lg-10 col-lg-offset-1">
                            <div className="nav-tabs-custom overlay-wrapper form-overlay-wrapper tab-form-overlay-wrapper">
								{this.renderBusyOverlay(isBusy)}

								{tabs}

                                <div className="tab-content">
                                    <div className={"tab-pane" + (this.state.activeTab === "address" ? " active" : "")}>
                                        <AddressTab parcel={this.state.parcel}
                                            errors={this.state.errors}
                                            isNew={false}
                                            isBusy={isBusy}
                                            ref={tab => this.addressTab = tab}
                                            onFieldChange={(name, value) => this.handleFieldChange(name, value)}
                                            onFieldEdited={(name, value) => this.handleFieldEdited(name, value)}
                                        />
                                    </div>

                                    <div className={"tab-pane" + (this.state.activeTab === "cargo" ? " active" : "")}>
                                        <CargoTab parcel={this.state.parcel}
                                            errors={this.state.errors}
                                            isNew={false}
                                            isBusy={isBusy}
                                            ref={tab => this.cargoTab = tab}
                                            onFieldChange={(name, value) => this.handleFieldChange(name, value)}
                                            onFieldEdited={(name, value) => this.handleFieldEdited(name, value)}
                                        />
                                    </div>

                                    <div className={"tab-pane" + (this.state.activeTab === "costCalc" ? " active" : "")}>
                                        <CostCalcTab
                                            setNewStatus={this.setNewStatus}
                                            parcel={this.state.parcel}
                                            errors={this.state.errors}
                                            isNew={false}
                                            isBusy={isBusy}
                                            ref={tab => this.costCalcTab = tab}
                                            clearErrors={() => this.clearErrors()}
											reload={() => this.reload()}
                                            onFieldChange={(name, value) => this.handleFieldChange(name, value)}
                                            onFieldEdited={(name, value) => this.handleFieldEdited(name, value)}
                                        />
                                    </div>

                                    <div className={"tab-pane" + (this.state.activeTab === "payer" ? " active" : "")}>
                                        <PayerTab parcel={this.state.parcel}
                                            errors={this.state.errors}
                                            isNew={false}
                                            isBusy={isBusy}
                                            ref={tab => this.payerTab = tab}
                                            onFieldChange={(name, value) => this.handleFieldChange(name, value)}
                                            onFieldEdited={(name, value) => this.handleFieldEdited(name, value)}
                                        />
                                    </div>

                                    <div className={"tab-pane clearfix" + (this.state.activeTab === "documents" ? " active" : "")}>
                                        <DocumentsTab parcel={this.state.parcel} 
											documents={this.state.documents} 
                                            isBusy={isBusy}
											reload={() => this.reload()}
											ref={tab => this.documentsTab = tab} 
										/>
                                    </div>

                                    <div className={"tab-pane clearfix" + (this.state.activeTab === "history" ? " active" : "")}>
                                        <HistoryTab history={this.state.history} ref={tab => this.historyTab = tab} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <InformationModal ref={modal => this.infoModal = modal} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./App/pages/parcels/form/parcelForm.jsx